import React from "react";

const RouteArrow: React.FC = () => {
    return (
        <span className="rioglyph rioglyph-play text-color-black" style={{ fontSize: "6px", marginTop: "1px", marginBottom: "1px" }} />
    );
};

export default RouteArrow;

